import { createFileRoute } from "@tanstack/react-router";
import { BidImportPage } from "../../../../../features/bid-import/bid-import-page";
import { ClientPricingDocumentImport } from "../../../../../features/client-pricing-document/client-pricing-document-import";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId/client-pricing-document_/import")({
  component: ClientPricingDocumentImportRoute,
});

function ClientPricingDocumentImportRoute() {
  const { dealId } = Route.useParams();
  return (
    <ClientPricingDocumentImport
      dealId={dealId}
      renderWizard={(reviewCompletion) => <BidImportPage reviewCompletion={reviewCompletion} />}
    />
  );
}
